"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PageError = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _client = require("@apollo/client");

var _locales = require("@meepshop/locales");

var _Error = _interopRequireDefault(require("./Error"));

var _Redirect = _interopRequireDefault(require("./Redirect"));

var _log = require("@meepshop/logger/lib/gqls/log");

// typescript import
// import
// graphql import
// definition
var PageError = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var _error$networkError, _error$networkError2, _error$networkError3;

  var error = _ref.error,
      loggerInfo = _ref.loggerInfo;

  var _useTranslation = (0, _locales.useTranslation)('apollo'),
      t = _useTranslation.t;

  var client = (0, _client.useApolloClient)();
  if (((_error$networkError = error.networkError) === null || _error$networkError === void 0 ? void 0 : _error$networkError.statusCode) !== 401) client.mutate({
    mutation: _log.log,
    variables: {
      input: {
        // FIXME: remove [FIXME] after using getServerSideProps
        type: ((_error$networkError2 = error.networkError) === null || _error$networkError2 === void 0 ? void 0 : _error$networkError2.statusCode) === 403 || /\[FIXME]/.test(error.message) ? 'WARN' : 'ERROR',
        name: 'PAGE_ERROR',
        data: {
          message: error.message,
          stack: error.stack,
          networkError: error.networkError,
          graphQLErrors: error.graphQLErrors
        }
      }
    }
  });

  switch ((_error$networkError3 = error.networkError) === null || _error$networkError3 === void 0 ? void 0 : _error$networkError3.statusCode) {
    case 401:
      return /*#__PURE__*/_react["default"].createElement(_Redirect["default"], null);

    case 403:
      return /*#__PURE__*/_react["default"].createElement(_Error["default"], {
        title: "The store does not exist",
        loggerInfoId: (loggerInfo === null || loggerInfo === void 0 ? void 0 : loggerInfo.id) || ''
      }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h1", null, /*#__PURE__*/_react["default"].createElement("span", null, t('store.title.1')), /*#__PURE__*/_react["default"].createElement("span", null, t('store.title.2'))), /*#__PURE__*/_react["default"].createElement("p", null, t('store.message'))));

    default:
      {
        var type = !error.networkError ? 'server' : 'network';
        return /*#__PURE__*/_react["default"].createElement(_Error["default"], {
          title: "".concat(type, " error"),
          loggerInfoId: (loggerInfo === null || loggerInfo === void 0 ? void 0 : loggerInfo.id) || ''
        }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h1", null, t("".concat(type, "-error.title"))), /*#__PURE__*/_react["default"].createElement("p", null, t("".concat(type, "-error.message"))), type !== 'network' ? null : /*#__PURE__*/_react["default"].createElement("p", null, "Please try again in a few minutes.")));
      }
  }
});

exports.PageError = PageError;

var _default = function _default(App) {
  var ErrorComponent = function ErrorComponent(_ref2) {
    var error = _ref2.error,
        loggerInfo = _ref2.loggerInfo,
        props = (0, _objectWithoutProperties2["default"])(_ref2, ["error", "loggerInfo"]);
    if (error) return /*#__PURE__*/_react["default"].createElement(PageError, {
      error: error,
      loggerInfo: loggerInfo
    });
    return /*#__PURE__*/_react["default"].createElement(App, props);
  };

  ErrorComponent.getInitialProps = App.getInitialProps;
  return ErrorComponent;
};

exports["default"] = _default;